import { reactive } from 'vue';

export const coreState = reactive({
    // --- Data Maps ---
    users: new Map(), // Map<id, User>
    shops: new Map(), // Map<id, Shop>
    members: new Map(), // Map<id, ShopMember> (RBAC pivot)
    qualifications: new Map(), // Map<id, Qualification>
    specialties: new Map(), // Map<id, Specialty>
    notifications: new Map(), // Map<id, Notification>

    // --- Global State ---
    activeUser: null,
    authSession: null,

    // --- Context ---
    currentShopId: null,
    currentUserRole: null,
    currentContextSite: null,

    // --- UI/Legacy State ---
    diveSites: [], // Used by Map Builder/Wizard predominantly
    calibration: {},
    feedItems: [],

    // UI Toggles
    profileDrawerOpen: false,
    profileDrawerUserId: null,
    profileDrawerMode: 'view',
    hideMobileNav: false,
    hideDesktopNav: false, // [NEW] Controls desktop sidebar visibility
    darkMode: (() => {
        if (typeof window !== 'undefined') {
            try {
                const storedTheme = localStorage.getItem('lewotobi-theme');
                if (storedTheme !== null) {
                    return storedTheme === 'dark';
                }
                if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                    return true;
                }
            } catch (e) {
                console.warn('Error reading theme from localStorage or matchMedia', e);
            }
        }
        return false;
    })(),
    isShopRegistrationOpen: false,

    // Offline / Network
    isSyncing: false,

    // Units
    unitSystem: (() => {
        if (typeof window !== 'undefined') {
            try {
                const storedUnits = localStorage.getItem('lewotobi-units');
                if (storedUnits) return storedUnits;
            } catch (e) { }
        }
        return 'metric';
    })(),

    // Toast
    toast: {
        visible: false,
        message: '',
        type: 'success',
        timeoutId: null
    }
});
